import type { GetDepositRequestsParams } from '../types/depositRequestsTypes'

export const depositRequestKeys = {
  all: ['treasury', 'depositRequests'] as const,

  lists: () => [...depositRequestKeys.all, 'list'] as const,
  list: (filters: GetDepositRequestsParams) => [...depositRequestKeys.lists(), filters] as const,

  details: () => [...depositRequestKeys.all, 'detail'] as const,
  detail: (id: string) => [...depositRequestKeys.details(), id] as const,

  statusCounts: () => [...depositRequestKeys.all, 'statusCounts'] as const,
}
